import { Card } from './ui/card';
import { Skeleton } from './ui/skeleton';

export const ProductCardSkeleton = () => {
  return (
    <Card className="p-4 flex flex-col hover:shadow-md transition-shadow h-full">
      {/* Product Image Skeleton */}
      <Skeleton className="w-full aspect-square bg-muted rounded-lg mb-3" />

      {/* Content Skeleton */}
      <div className="flex flex-col flex-1 items-center text-center gap-1">
        {/* Brand Skeleton */}
        <Skeleton className="h-3 w-16 mb-1" />

        {/* Product Name Skeleton */}
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-4 w-3/4 mb-4" />

        {/* Price Section Skeleton */}
        <div className="flex flex-col items-center gap-0.5 mt-auto mb-1">
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-12" />
        </div>

        {/* GST Info Skeleton */}
        <Skeleton className="h-3 w-20 mb-2" />
      </div>

      {/* Add Button Skeleton */}
      <Skeleton className="h-8 w-full mt-auto" />
    </Card>
  );
};